<!-- ── Modal Header ───────────────────────────────────────────── -->
<div class="modal-header d-flex justify-content-between">
  <h5 class="modal-title f-14 font-weight-600 mb-0">
@if (currentMode === 'preview') {
  Email Sending Limits
} @else if (currentMode === 'edit') {
  Configure Email Sending Limits
} @else if (currentMode === 'acknowledge') {
  Email Sending Limits Active
}
  </h5>
  <span type="button" class="close font-weight-normal f-16 ms-auto" data-bs-dismiss="modal" aria-bs-label="Close" (click)="dismiss()">
   <i class="fas fa-times f-14 text-black"></i>
  </span>
</div>

<!-- ── Acknowledge Mode ─────────────────────────────────────────── -->
 @if (currentMode === 'acknowledge') {
  <div class="modal-body">

    <!-- Info banner -->
    <div class="cl-ack-banner d-flex align-items-start mb-4">
      <span class="cl-ack-icon mr-3">&#9432;</span>
      <div>
        <p class="f-13 font-weight-600 mb-1">Email sending limits are currently active on your account.</p>
        <p class="f-12 gray-text mb-0">
          These limits protect your mailbox reputation by controlling how many emails your campaigns
          can send per hour and per day.
        </p>
      </div>
    </div>

    <!-- Active level summary -->
    <div class="d-flex align-items-center mb-4">
      <span class="f-12 gray-text mr-2">Current Safety Level:</span>
      <span class="cl-badge cl-badge--{{ activeLevelKey }}">{{ activeLevelLabel }}</span>
    </div>

    <!-- Stats -->
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <div class="cl-stat-card">
          <p class="cl-stat-value">{{ activeDailyDisplay }}</p>
          <p class="cl-stat-label">Emails per Day</p>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="cl-stat-card">
          <p class="cl-stat-value">{{ activeHourlyDisplay }}</p>
          <p class="cl-stat-label">Emails per Hour</p>
        </div>
      </div>
    </div>

    <p class="f-12 gray-text mb-0">
      Emails exceeding the active limit are automatically queued and sent when capacity becomes available.
    </p>

  </div>
  <div class="modal-footer">
    <button data-testid="auto-app-email-campaign-limits-button-1" type="button" class="btn btn-light btn-sm mr-2" (click)="acknowledge()">Close</button>
    <button data-testid="auto-app-email-campaign-limits-button-2" type="button" class="btn btn-primary btn-sm" (click)="switchToEdit()">Edit Limits</button>
  </div>
}

<!-- ── Preview Mode ───────────────────────────────────────────── -->
 @else if (currentMode === 'preview') {
  <div class="modal-body">

    <p class="f-12 gray-text mb-4">
      Sending limits protect your mailbox reputation. Control how many emails your campaigns send
      per hour and per day to avoid spam flags.
    </p>

    <!-- Selected level badge -->
    <div class="d-flex align-items-center mb-4">
      <span class="f-12 gray-text mr-2">Selected Safety Level:</span>
      <span class="cl-badge cl-badge--{{ activeLevelKey }}">{{ activeLevelLabel }}</span>
    </div>

    <!-- Stats -->
    <div class="row mb-3">
      <div class="col-md-6 mb-3">
        <div class="cl-stat-card">
          <p class="cl-stat-value">{{ activeDailyDisplay }}</p>
          <p class="cl-stat-label">Emails per Day</p>
        </div>
      </div>
      <div class="col-md-6 mb-3">
        <div class="cl-stat-card">
          <p class="cl-stat-value">{{ activeHourlyDisplay }}</p>
          <p class="cl-stat-label">Emails per Hour</p>
        </div>
      </div>
    </div>

    <p class="f-12 gray-text mb-1">{{ activeLevelNote }}</p>
    <p class="f-12 gray-text mb-0">
      Emails exceeding limits are automatically queued and sent when capacity becomes available.
    </p>

  </div>
  <div class="modal-footer">
    <button data-testid="auto-app-email-campaign-limits-button-3" type="button" class="btn btn-light btn-sm mr-2" (click)="dismiss()">Close</button>
    <button data-testid="auto-app-email-campaign-limits-button-4" type="button" class="btn btn-primary btn-sm" (click)="switchToEdit()">Edit Limits</button>
  </div>
 }
<!-- ── Edit Mode ─────────────────────────────────────────────── -->
 @else if (currentMode === 'edit') {
  <div class="modal-body">

    <table class="cl-level-table w-100">
      <thead>
        <tr>
          <th>Level</th>
          <th>Emails&nbsp;/&nbsp;Day</th>
          <th>Emails&nbsp;/&nbsp;Hour</th>
          <th>Notes</th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let lvl of levelConfig; let i = index"
          class="cl-level-row"
          [class.cl-level-row--selected]="pendingLevel === i"
          (click)="pendingLevel = i"
        >
          <td>
            <div class="d-flex align-items-center">
              <span class="cl-radio mr-2" [class.cl-radio--checked]="pendingLevel === i"></span>
              <span class="cl-badge cl-badge--{{ lvl.key }}">{{ lvl.label }}</span>
              <span *ngIf="i === 0" class="f-12 gray-text ml-2">(Default)</span>
            </div>
          </td>
          <td class="f-12 font-weight-600">{{ lvl.daily }}</td>
          <td class="f-12 font-weight-600">{{ lvl.hourly }}</td>
          <td class="f-12 gray-text">{{ lvl.note }}</td>
        </tr>
      </tbody>
    </table>

    <p class="f-12 gray-text mt-3 mb-0">
      Emails exceeding limits are automatically queued and sent when capacity becomes available.
    </p>

  </div>
  <div class="modal-footer">
    <button data-testid="auto-app-email-campaign-limits-button-5" type="button" class="btn btn-light btn-sm mr-2" (click)="cancelEdit()" [disabled]="saving">Cancel</button>
    <button data-testid="auto-app-email-campaign-limits-button-6" type="button" class="btn btn-primary btn-sm" (click)="saveChanges()" [disabled]="saving">
      <span *ngIf="saving" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>
      {{ saving ? 'Saving…' : 'Save changes' }}
    </button>
  </div>
 }
